<script>
  import AdminNav from '@/components/admin/AdminNav.svelte';
  import { router } from '@inertiajs/svelte'

  let { boards = [], pagination = {}, filters = {}, stats = {}, flash = {} } = $props()

  // svelte-ignore state_referenced_locally
  const initialBoardTypeFilter = filters.board_type || ''
  let boardTypeFilter = $state(initialBoardTypeFilter)

  function applyFilters() {
    const params = {}
    if (boardTypeFilter) params.board_type = boardTypeFilter
    router.get('/admin/boards', params, { preserveState: true })
  }

  function goToPage(page) {
    router.get('/admin/boards', { ...filters, page }, { preserveState: true })
  }

  function getTypeBadge(type) {
    switch (type) {
      case 'public': return 'badge-success'
      case 'verified_only': return 'badge-info'
      case 'admin_only': return 'badge-error'
      default: return 'badge-neutral'
    }
  }

  function getTypeLabel(type) {
    const labels = { public: '공개', verified_only: '인증회원', admin_only: '관리자' }
    return labels[type] || type
  }

  function toggleAllowView(boardId) {
    router.post(`/admin/boards/${boardId}/toggle_allow_view`, {}, { preserveState: false })
  }

  function toggleAllowWrite(boardId) {
    router.post(`/admin/boards/${boardId}/toggle_allow_write`, {}, { preserveState: false })
  }
</script>

<AdminNav activeTab="boards" />

  <main>
    {#if flash.notice}
      <div class="mb-6 p-4 bg-success-light dark:bg-success/20 border border-success/30 rounded-xl text-success-dark dark:text-success text-body2">
        {flash.notice}
      </div>
    {/if}
    {#if flash.alert}
      <div class="mb-6 p-4 bg-error-light dark:bg-error/20 border border-error/30 rounded-xl text-error-dark dark:text-error text-body2">
        {flash.alert}
      </div>
    {/if}

    <div class="flex items-center justify-between mb-6">
      <div class="flex items-center gap-4">
        <h2 class="text-h1 text-content">게시판 관리</h2>
        <div class="flex items-center gap-2 text-body2">
          <span class="px-3 py-1 bg-surface-tertiary text-content-secondary rounded-lg">전체 {stats.total || 0}</span>
          <span class="px-3 py-1 bg-success-light dark:bg-success/20 text-success-dark dark:text-success rounded-lg">공개 {stats.public || 0}</span>
          <span class="px-3 py-1 bg-info-light dark:bg-info/20 text-info-dark dark:text-info rounded-lg">인증 {stats.verified_only || 0}</span>
          <span class="px-3 py-1 bg-error-light dark:bg-error/20 text-error-dark dark:text-error rounded-lg">관리자 {stats.admin_only || 0}</span>
        </div>
      </div>
      <a href="/admin/boards/new" class="btn btn-primary btn-md">+ 게시판 추가</a>
    </div>

    <!-- Filters -->
    <div class="card card-bordered p-4 mb-6 shadow-md">
      <div class="flex flex-wrap items-center gap-4">
        <select bind:value={boardTypeFilter} class="select">
          <option value="">모든 유형</option>
          <option value="public">공개</option>
          <option value="verified_only">인증회원 전용</option>
          <option value="admin_only">관리자 전용</option>
        </select>
        <button onclick={applyFilters} class="btn btn-primary btn-md">검색</button>
      </div>
    </div>

    <!-- Boards Table -->
    <div class="card card-bordered overflow-hidden shadow-md">
      <table class="w-full">
        <thead class="bg-surface-tertiary">
          <tr>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">순서</th>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">게시판</th>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">슬러그</th>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">유형</th>
            <th class="px-6 py-3 text-center text-caption font-semibold text-content-tertiary uppercase">게시글</th>
            <th class="px-6 py-3 text-center text-caption font-semibold text-content-tertiary uppercase">카테고리</th>
            <th class="px-6 py-3 text-center text-caption font-semibold text-content-tertiary uppercase">보기</th>
            <th class="px-6 py-3 text-center text-caption font-semibold text-content-tertiary uppercase">글쓰기</th>
            <th class="px-6 py-3 text-center text-caption font-semibold text-content-tertiary uppercase">옵션</th>
            <th class="px-6 py-3"></th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-dark-border">
          {#each boards as board}
            <tr class="hover:bg-gray-50 dark:hover:bg-dark-tertiary transition-colors">
              <td class="px-6 py-4 text-body2 text-content-tertiary">{board.position}</td>
              <td class="px-6 py-4">
                <div class="text-body1 font-medium text-content">{board.name}</div>
              </td>
              <td class="px-6 py-4">
                <span class="text-body2 text-content-tertiary font-mono">{board.slug}</span>
              </td>
              <td class="px-6 py-4">
                <span class={`badge ${getTypeBadge(board.board_type)}`}>{getTypeLabel(board.board_type)}</span>
              </td>
              <td class="px-6 py-4 text-center text-body2 text-content-tertiary">{board.posts_count}</td>
              <td class="px-6 py-4 text-center text-body2 text-content-tertiary">{board.categories_count}</td>
              <td class="px-6 py-4 text-center">
                <button
                  onclick={() => toggleAllowView(board.id)}
                  class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary/50 {board.allow_view ? 'bg-success' : 'bg-gray-300 dark:bg-dark-border'}"
                  title={board.allow_view ? '보기 허용됨 (클릭하여 차단)' : '보기 차단됨 (클릭하여 허용)'}
                >
                  <span class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform shadow-sm {board.allow_view ? 'translate-x-6' : 'translate-x-1'}"></span>
                </button>
              </td>
              <td class="px-6 py-4 text-center">
                <button
                  onclick={() => toggleAllowWrite(board.id)}
                  class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary/50 {board.allow_write ? 'bg-success' : 'bg-gray-300 dark:bg-dark-border'}"
                  title={board.allow_write ? '글쓰기 허용됨 (클릭하여 차단)' : '글쓰기 차단됨 (클릭하여 허용)'}
                >
                  <span class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform shadow-sm {board.allow_write ? 'translate-x-6' : 'translate-x-1'}"></span>
                </button>
              </td>
              <td class="px-6 py-4 text-center">
                <div class="flex items-center justify-center gap-2">
                  {#if board.allow_anonymous}
                    <span class="text-caption text-content-tertiary" title="익명 허용">익명</span>
                  {/if}
                  {#if board.require_moderation}
                    <span class="text-caption text-warning-dark dark:text-warning" title="사전 검토">검토</span>
                  {/if}
                </div>
              </td>
              <td class="px-6 py-4 text-right">
                <div class="flex items-center justify-end gap-2">
                  <a href={`/admin/boards/${board.id}`} class="text-primary hover:text-primary-dark text-body2 font-medium">상세</a>
                  <a href={`/admin/boards/${board.id}/edit`} class="text-gray-500 hover:text-gray-700 dark:text-dark-text-low dark:hover:text-dark-text-high text-body2">수정</a>
                </div>
              </td>
            </tr>
          {/each}
        </tbody>
      </table>

      {#if boards.length === 0}
        <div class="text-center py-12 text-content-tertiary">
          게시판이 없습니다
        </div>
      {/if}
    </div>

    <!-- Pagination -->
    {#if pagination.total_pages > 1}
      <div class="flex items-center justify-center gap-2 mt-6">
        <button onclick={() => goToPage(pagination.current_page - 1)} disabled={pagination.current_page === 1} class="btn btn-secondary btn-sm disabled:opacity-50 disabled:cursor-not-allowed">이전</button>
        <span class="px-4 py-2 text-body2 text-content-tertiary">{pagination.current_page} / {pagination.total_pages}</span>
        <button onclick={() => goToPage(pagination.current_page + 1)} disabled={pagination.current_page === pagination.total_pages} class="btn btn-secondary btn-sm disabled:opacity-50 disabled:cursor-not-allowed">다음</button>
      </div>
    {/if}
  </main>
